<template>
  <div class="template-edit-component">
    <h1>THIS IS WORK IN PROGRESS</h1>

    <a-form :form="form">
      <div class="panel panel-default panel-stretch">
        <div class="panel-heading">
          Aplaza Account
        </div>
        <div class="panel-body">
          <a-row>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="Voornaam">
                <a-input v-decorator="[
                        'first_name',
                        {
                        initialValue: aplazaUser.first_name,
                          rules: [{
                            required: true,
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="Achternaam">
                <a-input v-decorator="[
                        'last_name',
                        {
                        initialValue: aplazaUser.last_name,
                          rules: [{
                            required: true,
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="EMS Postbusnummer">
                <a-input placeholder="EMS0000000000000"
                         v-decorator="[
                        'credentials[username]',
                        {
                        initialValue: aplazaUser.credentials.username,
                          rules: [{
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="EMS Wachtwoord">
                <a-input v-decorator="[
                        'credentials[password]',
                        {
                        initialValue: aplazaUser.credentials.password,
                          rules: [{
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="Bedrijfscertificaat">
                <a-input type="file"
                         ref="certificateFileInput"
                         style="height: initial;"
                         v-on:change="onCertificateFileChange"
                         v-decorator="[
                        'certificate[certificate]',
                        {
                        initialValue: aplazaUser.credentials.username,
                          rules: [{
                            required: true,
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" label="Certificaat Wachtwoord">
                <a-input type="password"
                         v-on:change="validateCertificate"
                         v-model="aplazaUser.certificate.password"
                         v-decorator="[
                        'certificate[password]',
                        {
                        initialValue: aplazaUser.certificate.password,
                          rules: [{
                            required: true,
                            message: 'Dit veld is verplicht',
                          }],
                        }
                      ]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="panel-footer text-right">
          <a-button type="primary" @click="onSubmit">Opslaan</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import certApi from '~/api/cert';
import aplazaUserApi from '~/api/aplazaUser';

const escapeStringRegexp = require('escape-string-regexp');

export default {
  name: "AplazaUserCreateComponent",
  props: {
  },
  components: {
  },
  data() {
    return {
      aplazaUser: {
        credentials: {
          username: null,
        },
        certificate: {
          certificate: null,
        },
      },
      certificateIsValid: null,
      formItemLayout: {
        labelCol: {span: 9},
        wrapperCol: {span: 14},
      },
      form: this.$form.createForm(this),
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onCertificateFileChange() {
      let file = this.$refs.certificateFileInput.$el.files[0];

      if(!file) {
        return;
      }

      let reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = evt => {
        this.aplazaUser.certificate.certificate = evt.target.result;
      }

      this.validateCertificate();
    },
    validateCertificate(e) {
      certApi.validateP12(this.aplazaUser.certificate.certificate, this.aplazaUser.certificate.password).then(response => {
        this.certificateIsValid = response.data.valid;
      }).catch(error => {
        this.certificateIsValid = false;
      })
    },
    onSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.shouldCreate) {
            templateApi.storeTemplate(values).then((response) => {
              window.location = this.redirectUri;
            }).catch((error) => {
              if (error.response.status === 400) {
                this.$notification['error']({
                  message: 'Validatie mislukt', //'Validation failed',
                  description: 'Sommige velden zijn niet gevuld of incorrect', //'Some required fields are missing or incorrect'
                });
              } else if (error.response.status === 500) {
                this.$notification['error']({
                  message: 'Er is iets fout gegaan',//'Something went wrong',
                  description: 'Probeer het later nogmaals', //'Something went wrong'
                });
              } else {
                this.$notification['error']({
                  message: 'Onbekende fout', //'Unknown error',
                  description: 'Er is een onbekende fout opgetreden',//'Unknown error'
                });
              }
            });
          } else {
            templateApi.updateTemplate(values).then((response) => {
              window.location = this.redirectUri;
            }).catch((error) => {
              if (error.response.status === 400) {
                this.$notification['error']({
                  message: 'Validation failed',
                  description: 'Some required fields are missing or incorrect'
                });
              } else if (error.response.status === 500) {
                this.$notification['error']({
                  message: 'Something went wrong',
                  description: 'Something went wrong'
                });
              } else {
                this.$notification['error']({
                  message: 'Unknown error',
                  description: 'Unknown error'
                });
              }
            });
          }
        }
      });
    },

    exists(load) {
      if (load !== undefined && load !== null) {
        return true
      }
      return false
    }
  }
}
</script>
<style module>
.fr-box .fr-view [contenteditable="false"] {
  display: inline-block;
  margin: 0 .2rem 0;
  border-radius: 0;
  padding: 2px;
  color: white;
  font-family: "Courier New", Courier, monospace;
  background-color: #0090CA;
}

.fr-box .fr-view [contenteditable="false"].focused {
  outline: 2px solid #2d8ac7;
}

.fr-box .fr-toolbar {
  border: none;
  border-bottom: solid 1px #ccc;
}

.fr-box.fr-basic .fr-wrapper {
  border: none;
}

.fr-box .second-toolbar {
  display: none;
}

.ant-form-item {
  margin-bottom: 4px;
}
</style>
<style scoped>
.definition {
  border: solid 1px #ccc;
  border-radius: .5rem;
  padding: 1.5rem 1rem;
  cursor: pointer;
}

.definition.active {
  background-color: #1a8ffc;
  color: white;
  border: solid 1px #0479e7;
  cursor: default;
}

.definition:not(.active):hover {
  background-color: #f1f1f1;
}

.relations {
  padding: 1rem 1.5rem;
}

.relations .item {
  margin-bottom: .5rem;
}

.email_recipient_tabs {
  width: 100%
}
</style>
